<template>
    <div id="submit-button-general">
        <h2>{{ Text }}</h2>
    </div>
</template>

<script>
export default {
    props:['Text']
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter&display=swap');
@media only screen and (max-width:420px){
    #submit-button-general{
        border-radius: 16px;
        width: 40vw;
        margin-left:30vw;
        margin-top:30px;
        height: 47px;
        background: var(--brand-color, #25AD34);
    }
    #submit-button-general h2{
        color: #FFF;
text-align: center;
font-family: Inter;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 47px;
    }
}
@media only screen and (min-width:480px) and (max-width:960px){
    #submit-button-general{
        border-radius: 16px;
        width: 30vw;
        margin-left:35vw;
        height: 57px;
        background: var(--brand-color, #25AD34);
        margin-top:30px;
    }
    #submit-button-general h2{
        color: #FFF;
text-align: center;
font-family: Inter;
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: 57px;
    }
}
@media only screen and (min-width:961px){
    #submit-button-general{
        border-radius: 16px;
        width: 20vw;
        margin-left:40vw;
        height: 57px;
        background: var(--brand-color, #25AD34);
        margin-top:30px;
        cursor: pointer;
        margin-bottom:4vh;
    }
    #submit-button-general h2{
        color: #FFF;
text-align: center;
font-family: Inter;
font-size: 24px;
font-style: normal;
font-weight: 400;
line-height: 57px;
    }
}
</style>